import InfluencerLoginPage from './InfluencerLoginPage';

export default InfluencerLoginPage;
